export const handleChangeZip = (event) => {
  const { target: { value } = {} } = event || {}
  if (/\D/.test(value) || value.length > 5) {
    event.preventDefault()
  }
}

export const zipValidation = (value, errorMessage) =>
  /(^\d{5}$)/.test(value) ? undefined : errorMessage || 'Please enter a valid ZIP Code'

export const zipZerosValidation = (value, errorMessage) => {
  return /^0{3}/.test(value) ? errorMessage || 'Please enter a valid ZIP Code' : undefined
}

export const validateZipWithPrefill = (v) => {
  return (v && zipValidation(v)) || (v && zipZerosValidation(v))
}

export const validateZipWithCustomMessage = (errorMessage) => (value) =>
  value && zipValidation(value, errorMessage)
